export const cents = (value: any, originValue: any) => {
  if (typeof originValue === "number") {
    value = (originValue * 1000) / 10; // to avoid cases like this 1.1 * 100 = 110.00000000001
  }
  return value;
};
